<template>
  <v-container fluid>
    <page-title icon="fas fa-fw fa-list">
      Products
      <template v-slot:buttons>
        <v-btn :to="{name: 'admin.product.create'}"
               color="primary">
          New Product
        </v-btn>
      </template>
    </page-title>

    <v-card>
      <v-alert v-if="1===2 && productsWithExternalIDs.length"
               type="info"
               tile
               dense>
        At least one of your products was imported from an external system, such as Veeva Vault.<br/>You can create new products, but you should not edit products from the external system.
      </v-alert>
      <products-table :products="products"
                      :loading="busy"
                      @updated="fetchData">
      </products-table>
    </v-card>
  </v-container>
</template>
<script>
import productService from '../../services/productService';
import ProductsTable from './components/ProductsTable';
import {orderBy} from 'lodash';
import {mapGetters} from 'vuex';
import PageTitle from '../../components/PageTitle.vue';

export default {
  components: {PageTitle, ProductsTable},
  data() {
    return {
      busy: false,
    }
  },
  computed: {
    ...mapGetters([
      'products',
    ]),
    productsWithExternalIDs() {
      return this.products.filter(p => !!p.external_id);
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      if (this.busy) {
        return;
      }
      this.busy = true;
      this.$store.dispatch('fetchProducts')
        .finally(() => {
          this.busy = false;
        })
    }
  }
}
</script>
